export default "__VITE_ASSET__DUZ2Bm1A__"